import { ReactNode } from 'react'
import { Button } from 'react-bootstrap'
import { userCurrentUser } from '@/features/apiSliceWithCurrentUser'
import { RecordType } from '@/components/shared/DeleteRecordModal'
import './RecordActionButtons.scss'
import { DeleteRecordButton } from '@/components/DeleteRecordButton'
import { useNavigate } from 'react-router'
import { apiPortals, apiProjects, apiAttachments } from '@/routes'

interface Props {
  idOrSlug: number | string,
  recordType: RecordType,
  showDetailsButton?: boolean
  onDeleted?: () => void,
  children?: ReactNode,
  redirectAfterDelete?: boolean,
}

function getController(recordType: RecordType) {
  switch (recordType) {
    case RecordType.Portal:
      return apiPortals
    case RecordType.Project:
      return apiProjects
    case RecordType.Attachment:
      return apiAttachments
  }
}

export default function RecordActionButtons({
  idOrSlug,
  recordType,
  showDetailsButton = true,
  onDeleted,
  children,
  redirectAfterDelete,
}: Props) {
  const currentUser = userCurrentUser()
  const navigate = useNavigate()
  const urlBase = `/${recordType + 's'}/${idOrSlug}/`

  const redirectToRecordsList = () => { navigate(`/${recordType + 's'}` + (recordType === RecordType.Project ? '/admin' : '')) }
  const handleDelete = () => {
    onDeleted?.()
    redirectAfterDelete && redirectToRecordsList()
  }

  return (
    <div className="RecordActionButtons d-flex gap-2 justify-content-between">
      {showDetailsButton &&
        <div className="d-flex gap-1">
          <Button
            variant="primary"
            size={'sm'}
            onClick={() => navigate(urlBase)}
          >
            Details
          </Button>
          {children}
        </div>
      }
      {currentUser?.role === 'admin' && (
        <div className="d-flex gap-1 ms-auto">
          <Button
            variant="primary"
            size={'sm'}
            onClick={() => navigate(urlBase + 'edit')}
          >
            Edit
          </Button>
          <DeleteRecordButton
            recordType={recordType}
            recordIdOrSlug={idOrSlug}
            onDeleted={handleDelete}
          />
        </div>
      )}

    </div>
  )
}
